export default __webpack_public_path__ + "static/media/triagleWarning.5a52ebcf.svg";